/**************************************************
 * Nombre:       Seccion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Tour from "./Componentes/Detalle_Tour";
import Detalle_Galeria from "./Componentes/Detalle_Galeria";
import Asesorate from "./Componentes/Asesorate";
import Equipo from "./Componentes/Equipo";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle = () => {
    const parms = useParams()
    const [tour, setTour] = useState({})

    useEffect(() => {

        irArriba()

        if (parms && parms.id) {
            obtenerDoc('tours', parms.id).then((dox) => {
                if (dox.res) {
                    setTour(dox.data)
                }
            })
        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Detalle_Tour item={tour}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Detalle_Galeria item={tour} />
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', marginTop: 54}}>
                <Asesorate/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Equipo/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Detalle